export default {
  STL: 'STL',
  GCODE: 'GCODE'
};
